import React from "react";
const NEON = "#00FF99";

export default function LeaveFilters({ filters, setFilters }) {
  const set = (k, v) => setFilters(prev => ({ ...prev, [k]: v }));
  return (
    <div className="bg-white/5 border border-white/10 rounded-2xl p-4">
      <div className="grid grid-cols-2 md:grid-cols-6 gap-3">
        <div>
          <label className="text-xs text-white/60">From</label>
          <input type="date" value={filters.from} onChange={e=>set("from", e.target.value)}
            className="w-full bg-black/30 border border-white/10 rounded-xl px-3 py-2 text-white" />
        </div>
        <div>
          <label className="text-xs text-white/60">To</label>
          <input type="date" value={filters.to} onChange={e=>set("to", e.target.value)}
            className="w-full bg-black/30 border border-white/10 rounded-xl px-3 py-2 text-white" />
        </div>
        <div>
          <label className="text-xs text-white/60">Location</label>
          <select value={filters.location} onChange={e=>set("location", e.target.value)}
            className="w-full bg-black/30 border border-white/10 rounded-xl px-3 py-2 text-white">
            <option>ALL</option><option>London</option><option>Bangalore</option><option>Remote</option>
          </select>
        </div>
        <div>
          <label className="text-xs text-white/60">Department</label>
          <select value={filters.department} onChange={e=>set("department", e.target.value)}
            className="w-full bg-black/30 border border-white/10 rounded-xl px-3 py-2 text-white">
            <option>ALL</option><option>Engineering</option><option>Product</option><option>QA</option><option>Ops</option>
          </select>
        </div>
        <div>
          <label className="text-xs text-white/60">Type</label>
          <select value={filters.type} onChange={e=>set("type", e.target.value)}
            className="w-full bg-black/30 border border-white/10 rounded-xl px-3 py-2 text-white">
            <option>ALL</option><option>Annual</option><option>Sick</option><option>Casual</option><option>Unpaid</option>
          </select>
        </div>
        <div>
          <label className="text-xs text-white/60">Status</label>
          <select value={filters.status} onChange={e=>set("status", e.target.value)}
            className="w-full bg-black/30 border border-white/10 rounded-xl px-3 py-2 text-white">
            <option>PENDING</option><option>APPROVED</option><option>REJECTED</option><option>OVERRIDDEN</option>
          </select>
        </div>
      </div>
      <div className="mt-3 text-xs text-white/60">
        Tip: Filters apply to KPIs, queue, and heatmap together.
      </div>
    </div>
  );
}
